// @ts-expect-error not migrated to TS
import ErrorBoundary from 'EmailComponents/errors/ErrorBoundary';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
// @ts-expect-error not migrated to TS
import FeedbackLoader from 'feedback-loader';
import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentLoading from 'email-management-lib/refactor/components/app/asyncLoaders/AsyncComponentLoading';
import ManageFrameworkContainer from 'email-management-lib/refactor/containers/manage/ManageFrameworkContainer';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncMailchimpImporterContainer = Loadable({
  loader: () => import(
  // @ts-expect-error not migrated to TS
  /* webpackChunkName: "mailchimp-importer" */
  'email-management-lib/refactor/containers/app/MailchimpImporterContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "mailchimp-importer"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "mailchimp-importer"
  }, props, {
    navMarkerErrorName: "MAILCHIMP_ERROR"
  }))
});
const AsyncAffectedEmailsContainer = Loadable({
  loader: () => import( /* webpackChunkName: "affected-emails" */'email-management-lib/AffectedEmails/containers/AffectedEmails'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "affected-emails"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "affected-emails"
  }, props))
});
const AsyncManageFoldersContainer = Loadable({
  loader: () => import( /* webpackChunkName: "manage-folders" */'email-management-lib/refactor/containers/manage/ManageFoldersContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "manage-folders"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "manage-folders"
  }, props))
});
export default function AppRoutes({
  onLoadFeedbackClient
}) {
  const location = useLocation();
  const isUngatedForNewFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const renderRedirect = useCallback(() => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "MANAGE_REDIRECT"
      }), /*#__PURE__*/_jsx(Redirect, {
        to: {
          pathname: '/manage',
          search: location.search
        }
      })]
    });
  }, [location]);
  const renderRedirectToFolders = useCallback(() => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "MANAGE_REDIRECT"
      }), /*#__PURE__*/_jsx(Redirect, {
        to: {
          pathname: '/manage/folders',
          search: location.search
        }
      })]
    });
  }, [location]);
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: ManageFrameworkContainer,
        exact: true,
        path: "/manage"
      }), /*#__PURE__*/_jsx(Route, {
        component: ManageFrameworkContainer,
        path: "/manage/state/:state(all|draft|scheduled|sent|archived|ai|issues|deleted|\\d+)"
      }), isUngatedForNewFrameworkFolders && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Route, {
          component: ManageFrameworkContainer,
          path: "/manage/folders/:folderId?"
        }), /*#__PURE__*/_jsx(Route, {
          path: "/manage/folder/:folderId?",
          render: renderRedirectToFolders
        })]
      }), !isUngatedForNewFrameworkFolders && /*#__PURE__*/_jsx(Route, {
        component: AsyncManageFoldersContainer,
        path: "/manage/folder/:folderId?"
      }), /*#__PURE__*/_jsx(Route, {
        component: ManageFrameworkContainer,
        path: "/manage/whitelisting"
      }), /*#__PURE__*/_jsx(Route, {
        component: ManageFrameworkContainer,
        path: "/manage/limits"
      }), /*#__PURE__*/_jsx(Route, {
        component: AsyncAffectedEmailsContainer,
        path: "/manage/affected-emails"
      }), /*#__PURE__*/_jsx(Route, {
        component: AsyncMailchimpImporterContainer,
        path: "/import/mailchimp"
      }), /*#__PURE__*/_jsx(Route, {
        path: "/",
        render: renderRedirect
      })]
    }), /*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(FeedbackLoader, {
      onClientLoad: onLoadFeedbackClient
    })]
  });
}